import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Store, AppFields, StorageUtil, DownloadUtil, AppTypes, Months } from '../../../store';
import { CommonService, MyTeamsService, MyProfileDashboardService } from '../../../services';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router';
import { CollegeRecrutingCenterService } from '../../../services/college-recruiting-center.service';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { AmChart, AmChartsService } from '@amcharts/amcharts3-angular';

@Component({
  selector: 'app-club-evaluation-dashboard',
  templateUrl: './evaluation-dashboard.component.html',
  styleUrls: ['./evaluation-dashboard.component.css']
})
export class ClubEvaluationDashboardComponent implements OnInit {

  links = [{ url: null, title: 'EVALUATIONS' }];

  public isEvaluationActivated: boolean = false;

  public openedFlyout: boolean = false;

  clubDetails: any = [];
  userDetails: any = [];

  selectedYear: number = new Date().getFullYear();
  public chart: AmChart;
  public pieChart: AmChart;

  public formCode: FormGroup;

  public evaluationsHasPlan: boolean;
  public planList: any[] = [];
  public evaluationStatistic = [];
  showTermsInModalOpened = false;

  public subscriptionPlans: any;
  public year: number = new Date().getFullYear();
  collegeViewDropdownYears = [];
  public evaluationStatistics: any;
  public evaluationStatuses: any;
  evaluationByMonthList: any[] = [];
  slowestAvgCompletionList: any[] = [];
  productTypeID: number;

  constructor(
    private store: Store<any>,
    public _myTeamsService: MyTeamsService,
    private _service: CollegeRecrutingCenterService,
    private _serviceClub: MyProfileDashboardService,
    private loader: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private router: Router,
    private chartService: AmChartsService,
    private _http: HttpClient
  ) {
    //price_1HQL9jLORl0Suru9BlBmf8zz
    this.planList = [
      {
        productPlanID: 123,
        planTitle: "Evaluations",
        subTitle: "Unlimited Player Evaluations & Templates",
        price: 1500,
        recurring: "Yearly"
      }
    ];

    this.store.select(AppFields.App, AppFields.Club).subscribe((club) => {
      if (club != null) {
        this.clubDetails = club;
      }
    });
    this.store.select(AppFields.App, AppFields.User).subscribe((user) => {
      if (user != null) {
        this.userDetails = user;
      }
    });
    this.store.select(AppFields.App, AppFields.SubscriptionPlans).subscribe((rs) => {

      if (rs != null) {
        this.subscriptionPlans = rs;
        if (rs.hasEvaluationPlan) {
          let temp = {
            ProductType: rs.evaluationProductType,
            PlanRenewsOnDate: rs.evaluationPlanRenewsOnDate,
            ProductAmount: rs.evaluationProductAmount,
            StripeSubscriptionID: rs.evaluationStripeSubscriptionID,
            HasPlan: rs.hasEvaluationPlan,
            HasPlanCancelled: rs.hasEvaluationPlanCancelled
          }
          this.subscriptionPlans = temp;
          this.getClubEvaluationDashboardData(0);
        }
        this.productTypeID = rs.evaluationProductTypeID;
        this.evaluationsHasPlan = rs.hasEvaluationPlan;
      }
    });
  }

  ngOnInit() {
    this.initForm();
    this.setDropDownYear()
  }
  getClubEvaluationDashboardData(flag: number) {
    this.loader.show();
    setTimeout(() => {
      this._serviceClub.getClubEvaluationDashboardData(StorageUtil.clubID, this.selectedYear, flag).subscribe((rs: any) => {
        if (rs) {
          if (flag == 0) {
            this.evaluationStatistics = rs.data.evaluationStatistics;
            let playerEvaluation = this.evaluationStatistics.avgTimeToCompletePlayerEval > 1 ? ' Days' : ' Day';
            let staffEvaluation = this.evaluationStatistics.avgTimeToCompleteStaffEval > 1 ? ' Days' : ' Day';
            this.evaluationStatistic = [
              { 'name': 'Average player Score', 'score': this.evaluationStatistics.avgPlayerScore },
              { 'name': 'Average Yearly Player Evaluations', 'score': this.evaluationStatistics.yearlyPlayerEvaluations },
              { 'name': 'Average Staff Score', 'score': this.evaluationStatistics.avgStaffScore },
              { 'name': 'Average Yearly Staff Evaluations', 'score': this.evaluationStatistics.yearlyStaffEvaluation },
              { 'name': 'Average Time To Complete a Player Evaluation', 'score': this.evaluationStatistics.avgTimeToCompletePlayerEval + playerEvaluation },
              { 'name': 'Average Time To Complete a Staff Evaluation', 'score': this.evaluationStatistics.avgTimeToCompleteStaffEval + staffEvaluation },
              { 'name': 'Total Active Evaluation Templates', 'score': this.evaluationStatistics.totalActiveEvaluationTemplates }
            ]
            this.evaluationStatuses = rs.data.evaluationStatuses;
            // this.pieChart = this.chartService.makeChart("college-views-by-division", this.loadPieGraph(this.evaluationStatuses));
            this.updatePieChart(this.evaluationStatuses);
            this.slowestAvgCompletionList = rs.data.slowestAvgCompletionList;
          }
          this.evaluationByMonthList = rs.data.evaluationByMonthList;
          this.updateChart();
        }

        this.loader.hide();
      }, (error) => {
        console.log(error.error);
        this.loader.hide();
      });
    }, 1500);
  }

  updateChart() {
    // const dataByYearMale = _.groupBy(this.collegeViewsByMonth.filter(n => n.gender == "m"), (payment) => payment.year);
    //const dataByYearFemale = _.groupBy(this.collegeViewsByMonth.filter(n => n.gender == "f"), (payment) => payment.year);

    // this.chart.graphs[0].title = "College views by month male";
    // this.chart.graphs[1].title = "College views by month female";

    // const dataMale: any = dataByYearMale[this.selectedYear] || [];
    // const dataFemale: any = dataByYearFemale[this.selectedYear] || [];

    // var dateNow = new Date();
    // const years = [dateNow.getFullYear(), dateNow.getFullYear() - 1, dateNow.getFullYear() - 2, dateNow.getFullYear() - 3, dateNow.getFullYear() - 4, dateNow.getFullYear() - 5];
    //if (years.length) {
    this.chart.dataProvider = Months.map((month, idx) => {
      //  const cpIndexMale = dataMale.findIndex(d => d.month === idx + 1);
      // const cpIndexFemale = dataFemale.findIndex(d => d.month === idx + 1);
      return {
        date: month,
        viewsByMonthMale: this.evaluationByMonthList[idx].male,
        viewsByMonthFemale: this.evaluationByMonthList[idx].female
      };
    });
    this.chart.validateData();
    //}
  }

  loadPieGraph(clubPlayerInjuryStatusChart) {


    let objectKeys = Object.keys(clubPlayerInjuryStatusChart);
    let colors: any[] = [];
    let clubPlayerInjuryStatusChartData: any[] = [];


    if (clubPlayerInjuryStatusChart != null) {
      _.map(objectKeys, function (value: any, key) {
        let data: any;
        if (value == "completed") {
          data = { 'name': 'Completed', 'totalCompleted': clubPlayerInjuryStatusChart.completed };
          colors.push("#72ABD1");
        } else if (value == "inProgress") {
          data = { 'name': 'InProgress', 'totalCompleted': clubPlayerInjuryStatusChart.inProgress };
          colors.push("#9DDBD5");
        } else if (value == "new") {
          data = { 'name': 'InCompleted', 'totalCompleted': clubPlayerInjuryStatusChart.new };
          colors.push("#9F9FA0");
        } else if (value == "total") {
          // data = { 'name': 'total', 'totalCompleted': clubPlayerInjuryStatusChart.total };
          // colors.push("#9P9FA0");
        }

        if (data)
          clubPlayerInjuryStatusChartData.push(data)

      });
    }

    return {
      "type": "pie",
      "theme": "none",
      "dataProvider": clubPlayerInjuryStatusChartData,
      "colors": colors,
      "titleField": "name",
      "valueField": "totalCompleted",
      "labelRadius": 2,
      "radius": "40%",
      // "innerRadius": "20%",
      "labelText": "[[title]]",
      "export": {
        "enabled": true
      }
    }
  }

  updatePieChart(collegeViewsByDevision) {
    this.pieChart = this.chartService.makeChart("college-views-by-division", this.loadPieGraph(collegeViewsByDevision));
  }

  ngAfterViewInit() {
    this.chart = this.chartService.makeChart('college-views-by-month', {
      type: 'serial',
      theme: 'light',
      marginRight: 40,
      marginLeft: 40,
      autoMarginOffset: 20,
      synchronizeGrid: true,
      responsive: {
        enabled: true
      },
      graphs: [
        {
          fillAlphas: 0.8,
          lineAlpha: 0.2,
          type: 'column',
          valueField: `viewsByMonthMale`,
          balloonText: '<strong>[[value]]</strong> males',
          title: 'College Views By Month Graph Male',
          fillColors: '#5c80d1'
        },
        {
          fillAlphas: 0.8,
          lineAlpha: 0.2,
          type: 'column',
          valueField: `viewsByMonthFemale`,
          balloonText: '<strong>[[value]]</strong> females',
          title: 'College Views By Month Graph Female',
          fillColors: '#373737'
        }
      ],
      chartCursor: {
        cursorPosition: 'mouse'
      },
      categoryField: 'date',
      // dataDateFormat:'MMM',
      categoryAxis: {
        autoRotateAngle: 15,
        autoRotateCount: 8,
        autoWrap: true
      }
    });
  }

  initForm() {
    this.formCode = this.fb.group({
      Code: ['', [Validators.required]]
    });
  }

  redirect() {
    window.open(
      'https://calendly.com/tgs-products/evaluation-review', '_blank');
  }

  /* Flyout Section */

  getClubEvaluationsPlans() {
    this.loader.show();
    this._service.getClubEvaluationsPlans().subscribe((result: any) => {
      //console.log("getClubCollegeRecruitingPlans =>", result);
      this.planList = result;
      this.loader.hide();
    }, (error) => {
      this._alertService.error('Failed to load data');
      this.closeSideOverlay();
      console.log(error.error);
      this.loader.hide();
    });
  }

  onActiveNow() {
    //this.router.navigate(['/high-five-success/Evaluations']);
    this.openedFlyout = true;
    this.getClubEvaluationsPlans();
  }

  closeSideOverlay() {
    this.openedFlyout = false;
  }

  getClubSubscriptionPlans() {
    this._service.getClubTeamSubscriptionPlansWithPlanName(StorageUtil.clubID, StorageUtil.teamId || 0).subscribe((rs: any) => {
      this.subscriptionPlans = rs;
      if (rs.hasEvaluationPlan) {
        let temp = {
          ProductType: rs.evaluationProductType,
          PlanRenewsOnDate: rs.evaluationPlanRenewsOnDate,
          ProductAmount: rs.evaluationProductAmount,
          StripeSubscriptionID: rs.evaluationStripeSubscriptionID,
          HasPlan: rs.hasEvaluationPlan,
          HasPlanCancelled: rs.hasEvaluationPlanCancelled
        }
        this.subscriptionPlans = temp;
      }
      this.evaluationsHasPlan = rs.hasEvaluationPlan;
      this.productTypeID = rs.evaluationProductTypeID;
      this.store.dispatch({
        type: AppTypes.UpdateState,
        payload: {
          [AppFields.SubscriptionPlans]: rs
        }
      });
    });
  }

  setDropDownYear() {
    var startYear = (new Date().getFullYear() - 1);
    var currentYear = new Date().getFullYear();
    while (startYear <= currentYear) {
      this.collegeViewDropdownYears.unshift(startYear);
      startYear++;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/club-evaluations/evaluation-dashboard/evaluation-dashboard.component.ts